var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("b-form-datepicker", {
        attrs: {
          id: "date",
          placeholder: "Nenhuma Data",
          "calendar-width": "200",
          "label-no-date-selected": "",
          "label-next-month": "Próximo Mês",
          "label-next-year": "Próximo Ano",
          "label-prev-month": "Mês Anterior",
          "label-prev-year": "Ano Anterior",
          "label-current-month": "Mês Atual",
          "label-help": "",
          "hide-header": "",
          "reset-button": "",
          "reset-button-variant": "danger",
          "label-reset-button": "Limpar",
          size: _vm.size,
          "date-format-options": {
            year: "numeric",
            month: "numeric",
            day: "numeric"
          },
          locale: "pt-BR"
        },
        on: {
          input: function($event) {
            return _vm.onInput(_vm.date)
          }
        },
        model: {
          value: _vm.date,
          callback: function($$v) {
            _vm.date = $$v
          },
          expression: "date"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-477d7bea", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-477d7bea","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/util/Calendario.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-477d7bea","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/util/Calendario.vue
// module chunks = 2